module.exports = __webpack_public_path__ + "img/ford.61974457.svg";